import React, { Fragment, useEffect, useState } from "react";
import GatewayCard from "../../global/GatewayCard";
import { SolidButton } from "../../global/SolidButton";
import { Plus, Upload, User } from "lucide-react";
import { MyModal } from "../../global/MyModal";
import {
  addGateway,
  deleteGateway,
  getGateways,
  updateGatewayStatus,
} from "../apps_manage/api";

import MyLoader from "../../util/MyLoader";
import toast from "react-hot-toast";

export default function Gateways() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [icon, setIcon] = useState("");
  const [gateway, setGateway] = useState("");
  const [service, setService] = useState("");
  const [isEnable, setIsEnable] = useState(false);
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);

  const fetchGateways = async () => {
    try {
      const res = await getGateways();
      if (res.status === 200) {
        const data = res?.data;
        setGateways(data.gateways || []);
      }
    } catch (err) {
      console.error("failed to fetch gateways :", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchGateways();
  }, []);

  const validateForm = () => {
    const errs = {};
    if (icon === "") {
      errs.icon = "icon is required";
    }
    if (gateway === "") {
      errs.gateway = "select gateway";
    }
    if (service === "") {
      errs.service = "service is required";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;
    const payload = {
      icon: icon,
      gateway: gateway,
      service: service,
      status:isEnable?1:0
    };
    const addGatewayD = async () => {
      try {
        const res = await addGateway(payload);
        if (res.status === 201) {
          setGateway("");
          setService("");
          setIcon("");
          setErrors({});
          setIsModalOpen(false);
          fetchGateways();
          toast.success(res?.data.status);
        }
      } catch (err) {
        console.error("failed to submit :", err);
      }
    };

    addGatewayD();
  };

  const handleDlt = async () => {
    try {
      const res = await deleteGateway(deleteId);
      if (res.status === 200) {
        const data = res?.data;
        fetchGateways();
        toast.success(data.status || "Gateway deleted");
      }
    } catch (err) {
      console.error("failed to delete", err);
    }
    setDeleteId(null);
  };

  const gatewayStatus = async (status, id, title) => {
    try {
      const st = status ? 1 : 0;
      const res = await updateGatewayStatus(id, st);

      if (res?.status === 200) {
        toast.success((status ? "Active" : "Inactive") + `:${title}`);
      }
    } catch (err) {
      toast.error("Failed to update", err);
    }
  };
  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4">
        <div className="flex items-center justify-end">
          <SolidButton onClick={() => setIsModalOpen(true)}>
            <Plus className="w-4 h-4" />
            <span>Add Gateway</span>
          </SolidButton>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {gateways.map((item) => (
            <div key={item.id}>
              <GatewayCard
                title={item.service}
                subtitle={item.gateway}
                icon={
                   item.icon ??
                  "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/768px-Google_%22G%22_logo.svg.png"
                }
                g_status={item.status===1?true:false}
                onDelete={() => setDeleteId(item.id)}
                onUpdate={(status) =>
                  gatewayStatus(status, item.id, item.Service)
                }
              />
            </div>
          ))}
          {/* <GatewayCard
            title={"Google Pay"}
            subtitle={"xoxo-day"}
            icon={
              "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/768px-Google_%22G%22_logo.svg.png"
            }
          />

          <GatewayCard
            title={"Bank"}
            subtitle={"cashfree"}
            icon={"https://pngimg.com/d/bank_PNG1.png"}
          />

          <GatewayCard
            title={"UPI"}
            subtitle={"cashfree"}
            icon={"https://img.icons8.com/color/512/bhim.png"}
          />

          <GatewayCard
            title={"Amazon Gift Card"}
            subtitle={"xoxo-day"}
            icon={"https://pngimg.com/d/amazon_PNG18.png"}
          />

          <GatewayCard
            title={"FREEFIRE"}
            subtitle={"giftcode"}
            icon={
              "https://lh3.googleusercontent.com/LJxdq84-4j_f6uuq4EJzpXBve7_wGjuD7tGo84yEUqMo2IqVgZlyE-qAQkAEJyCCF3AT"
            }
          />

          <GatewayCard
            title={"BGMI"}
            subtitle={"giftcode"}
            icon={
              "https://img.tapimg.net/market/images/ac76622998cada2930cf1a4c86287930.png/appicon_m?t=1"
            }
          /> */}
        </div>
      </div>
      {/* add gateway */}
      <MyModal
        isOpen={isModalOpen}
        title={"Add New Gateway"}
        onClose={() => {
          setIsModalOpen(false);
          setErrors({});
          //  setAvatar(null);
        }}
        children={
          <>
            {/* profile */}
            <div className="flex flex-col items-start justify-start">
              <label className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
                Icon*
              </label>

              <div className="w-full flex items-center justify-start space-x-4 mt-2">
                <div className="">
                  {icon !== "" ? (
                    <img
                      className=" object-cover h-12 w-12 rounded-lg"
                      src={icon}
                      alt="profile"
                    />
                  ) : (
                    <Upload
                      className=" h-14 w-14 p-2 rounded-lg text-slate-600 dark:text-slate-300
      bg-slate-400/20 dark:bg-slate-700 "
                    />
                  )}
                </div>
                {/* file input */}
                <div className="flex flex-col w-full">
                  <input
                    type="text"
                    name="icon"
                    value={icon}
                    aria-invalid={!!errors.icon}
                    onChange={(e) => {
                      setIcon(e.target.value);
                      if (errors.icon)
                        setErrors((prev) => ({ ...prev, icon: undefined }));
                    }}
                    placeholder="Enter Image URL"
                    id=""
                    className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${
                errors.icon
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
                  />
                  {errors.icon && (
                    <div className="text-xs text-red-500 mt-1">
                      {errors.icon}
                    </div>
                  )}
                  <span className="text-[10px] dark:text-slate-500 text-slate-500 mt-[6px]">
                    e.g.,https://media.adwave.in/icons/gateways/upi{" "}
                  </span>
                </div>
              </div>

              {/* Gateway Name */}
              <label className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-4 ">
                Gateway*
              </label>
              <select
                name="gateway"
                value={gateway}
                //  defaultValue={"razorpay"}
                aria-invalid={!!errors.gateway}
                onChange={(e) => {
                  setGateway(e.target.value);
                  if (errors.gateway)
                    setErrors((prev) => ({ ...prev, gateway: undefined }));
                }}
                placeholder="Enter Gateway Name"
                id=""
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${
                errors.gateway
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
              >
                <option value="">Select Gateway</option>
                <option value="adwave">Adwave</option>
                <option value="razorpay">Razorpay</option>
                <option value="cashfree">Cashfree</option>
                <option value="xoxoday">XoxoDay</option>
                <option value="giftcode">Gift code</option>
              </select>
              <span className="text-[10px] dark:text-slate-500 text-slate-500 mt-[6px]">
                e.g.,cashfree,razorpay,xoxoday
              </span>
              {errors.gateway && (
                <div className="text-xs text-red-500 mt-1">
                  {errors.gateway}
                </div>
              )}
              {/* Service */}
              <h1 className=" text-sm  font-medium text-black-600 dark:text-slate-200 mt-5 ">
                Service*
              </h1>
              <input
                type="text"
                name="service"
                placeholder="Enter Service"
                id=""
                value={service}
                onChange={(e) => {
                  setService(e.target.value);
                  if (errors.service)
                    setErrors((prev) => ({ ...prev, service: undefined }));
                }}
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border 
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all
              ${
                errors.service
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }
              `}
              />
              {errors.service && (
                <div className="text-xs text-red-500 mt-1">
                  {errors.service}
                </div>
              )}
              <span className="text-[10px] dark:text-slate-500 text-slate-500">
                E.g. UPI,Bank Transfer
              </span>

              <div className="space-x-2 p-2 flex items-start justify-start rounded-lg bg-slate-300/30 dark:bg-slate-200/10 border border-slate-300 dark:border-slate-700 mt-6">
                <input
                  className="w-5 h-5 rounded-2xl p-0 flex items-start justify-start "
                  type="checkbox"
                  name="enableCoinVariation"
                  checked={isEnable}
                  value={isEnable}
                  onChange={() => setIsEnable((prev) => !prev)}
                />

                <div className="flex flex-col items-start justify-start ">
                  <h1 className="text-start text-xs  text-slate-800 dark:text-slate-200 font-bold">
                    Enable
                  </h1>
                  <p className="text-start text-[12px]  text-slate-700 dark:text-slate-400 font-normal">
                    When enabled, the this gateway will be enable on all apps.
                  </p>
                </div>
              </div>
              {/* line */}
              <div className="bg-slate-500/20 dark:bg-slate-400/20  w-full h-[1px] mt-4" />

              <div className="flex items-center justify-end space-x-4 mt-4 ml-auto">
                <button
                  className="px-4 py-2 rounded-lg
             bg-slate-400/20 dark:bg-slate-800 
             text-slate-800 dark:text-slate-300 text-sm font-semibold
             hover:bg-slate-400/30 dark:hover:bg-slate-700 
             transition-all duration-300"
                  onClick={() => {
                    setIsModalOpen(false);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
                <SolidButton
                  children={<span>Add New</span>}
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                />
              </div>
            </div>
          </>
        }
      />
      {/* dlt CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Gateway?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this Gateway?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDlt} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
